<template>

  <div>
    <div class="card">
        <div class="card-header">Personal Information</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    Please fill in all applicable information.
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="Last Name:" :value="renewalApplication.lastName"/>
                </b-col>
                <b-col cols="12" lg="3">
                    <BaseTextOutput label="First Name:" :value="renewalApplication.firstName"/>
                </b-col>
                <b-col cols="12" lg="3">
                    <BaseTextOutput label="Middle Name:" :value="renewalApplication.middleName"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="5">
                    <BaseTextOutput label="Social Security Number:" :value="renewalApplication.ssn"/>
                </b-col>
                <b-col cols="12" lg="5">
                    <BaseTextOutput label="Date of Birth:" :value="formatDate(renewalApplication.dateOfBirth)"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <BaseTextInput v-model="renewalApplication.contact.address.streetAddress"
                                   :v="$v.renewalApplication.contact.address.streetAddress"
                                   slug="streetAddress"
                                   label="Street Address"
                                   setId="applStreetAddress"
                                   tip="Please include apartment number or PO Box number if relevant."/>
                </b-col>
                <b-col cols="4">
                    <BaseTextInput v-model="renewalApplication.contact.address.city"
                                   :v="$v.renewalApplication.contact.address.city"
                                   slug="city"
                                   label="City"
                                   setId="applCity"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseSelector v-model="renewalApplication.contact.address.state"
                                  :v="$v.renewalApplication.contact.address.state"
                                  slug="state"
                                  label="State"
                                  :options="opts.stateOptions"
                                  setId="appState"/>
                </b-col>
                <b-col cols="12" lg="3">
                    <BaseMaskedTextInput v-model="renewalApplication.contact.address.postalCode"
                                         :v="$v.renewalApplication.contact.address.postalCode"
                                         slug="postalCode"
                                         label="ZIP"
                                         setId="applZip"
                                         mask="#####-####"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="4">
                    <BaseMaskedTextInput v-model="renewalApplication.contact.phone"
                                         :v="$v.renewalApplication.contact.phone"
                                         slug="phone"
                                         label="Cell Phone Number"
                                         setId="phone"
                                         mask="(###)###-####"/>
                </b-col>
                <b-col cols="12" lg="8">
                    <BaseTextInput v-model="renewalApplication.contact.email"
                                   :v="$v.renewalApplication.contact.email"
                                   slug="email"
                                   label="Email Address"
                                   setId="applEmailAdddress"/>
                </b-col>
            </b-row>
            <b-modal id="name-modal" hide-header hide-footer>
                <h2>Update Name</h2>
                <hr/>
                <form ref="form">
                    <NameUpdate class="mb-2" v-on:attachment-complete="closeNameModal"/>
                    <b-button @click="closeNameModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                </form>
            </b-modal>
            <b-modal id="ssn-modal" hide-header hide-footer>
                <h2>SSN Update</h2>
                <hr/>
                <form ref="form">
                   <SsnUpdate class="mb-2" v-on:attachment-complete="closeSsnModal"/>
                    <b-button @click="closeSsnModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                </form>
            </b-modal>
        </div>
    </div>
  </div>
</template>

<script>
    import BaseTextInput from "@/components/templates/input/BaseTextInput";
    import BaseSelector from "@/components/templates/input/BaseSelector";
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
    import { required, email, maxLength, minLength } from 'vuelidate/lib/validators';
    import {commonOptions} from "@/mixins/commonOptions";
    import SsnUpdate from "@/views/cna-user/SsnUpdate";
    import NameUpdate from "@/views/cna-user/NameUpdate";
    import moment from 'moment';
    import axiosRetry from "axios-retry";
    import axios from "axios";

    export default {

        components:{
            NameUpdate,
            SsnUpdate,
            BaseTextInput,
            BaseSelector,
            BaseTextOutput
        },

        mixins: [
            commonOptions
        ],

        props:{
            renewalApplication: [Object],
            profile: [Object]
        },

        validations(){
            return{
                renewalApplication: {
                    contact: {
                        required: true,
                        email: {required, email},
                        phone: {required},
                        address:{
                            required: true,
                            streetAddress: { required },
                            city: { required },
                            state: { required },
                            postalCode: {
                                required,
                                minLength: minLength(5),
                                maxLength: maxLength(10)
                            },
                            applicationId: { required: false }
                        }
                    },
                },
                form: ["renewalApplication"]
            }
        },
        methods:{
            validate(){
                this.$v.form.$touch();
                let isValid = !this.$v.form.$invalid;
                this.$emit('on-validate', this.$data.renewalApplication, isValid);
                return isValid;
            },
            showNameModal() {
                this.$bvModal.show('name-modal')
            },
            closeNameModal() {
                this.$bvModal.hide('name-modal')
            },
            showSsnModal() {
                this.$bvModal.show('ssn-modal')
            },
            closeSsnModal() {
                this.$bvModal.hide('ssn-modal')
            },
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
        },

    }
</script>